// src/AuthContext.jsx
import { createContext, useEffect, useState, useMemo, useCallback } from 'react';
import API_BASE from './apiConfig';

const AuthContext = createContext({
  user: null,
  currentCompany: null,
  setUser: () => {},
  setCurrentCompany: () => {},
  refreshAuth: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);

  // EN gemensam funktion för att hämta /auth/me
  const refreshAuth = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/auth/me`, { credentials: 'include' });
      if (!res.ok) {
        // inte inloggad / session död
        setUser(null);
        setCurrentCompany(null);
        return;
      }

      const json = await res.json();
      if (!json?.ok || !json?.user) {
        setUser(null);
        setCurrentCompany(null);
        return;
      }

      // json.user = { id, email, company_id, role, ... }
      setUser(json.user);

      // om backend skickar company, använd den – annars använd company_id
      if (json.company) {
        setCurrentCompany(json.company);
      } else if (json.user.company_id) {
        setCurrentCompany({ id: json.user.company_id });
      }
    } catch {
      // vid nätverksfel: behåll senaste kända state, gör inget
    }
  }, []);

  // Kör en gång när appen startar (som tidigare)
  useEffect(() => {
    refreshAuth();
  }, [refreshAuth]);

  const value = useMemo(
    () => ({
      user,
      currentCompany,
      setUser,
      setCurrentCompany,
      refreshAuth,
    }),
    [user, currentCompany, refreshAuth]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthContext;
